// src/strings/landingPageStrings.js
const landingPageStrings = {
  en: {
    navbar: {
      login: "Login",
      register: "Register",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
    },
    heading: {
      welcome: "TA",
      connect: "Connect",
      subtitle: "Maximize Your Learning. Minimize the Wait.",
    },
    steps: [
      {
        title: "1. Browse TAs",
        description: "See the list of available teaching assistants and their office hours.",
      },
      {
        title: "2. Schedule a Session",
        description: "Book a time slot with your chosen teaching assistant.",
      },
      {
        title: "3. Manage Appointments",
        description: "View and modify your scheduled sessions with teaching assistants.",
      },
    ],
    footer: {
      copyright: "TAConnect © 2025. All rights reserved.",
      github: "GitHub Repository",
      about: "About",
      contact: "Contact",
      quickLinks: "Quick Links",
      followUs: "Follow Us",
      team: "Our Team",
    },
  },
  ar: {
    navbar: {
      login: "تسجيل الدخول",
      register: "إنشاء حساب",
      darkMode: "الوضع الداكن",
      lightMode: "الوضع الفاتح",
    },
    heading: {
      welcome: "TA",
      connect: "Connect",
      subtitle: "عظّم تعلمك. قلّل الانتظار.",
    },
    steps: [
      {
        title: "1. تصفح المعيدين",
        description: "اطلع على قائمة المعيدين المتاحين ومواعيد ساعاتهم المكتبية.",
      },
      {
        title: "2. احجز جلسة",
        description: "احجز موعداً مع المعيد الذي تختاره.",
      },
      {
        title: "3. إدارة المواعيد",
        description: "اعرض وعدّل مواعيدك المحجوزة مع المعيدين.",
      },
    ],
    footer: {
      copyright: "TAConnect © 2025. جميع الحقوق محفوظة.",
      github: "مستودع GitHub",
      about: "عن البرنامج",
      contact: "تواصل معنا",
      quickLinks: "روابط سريعة",
      followUs: "متابعتنا",
      team: "فريقنا",
    },
  },
};

export default landingPageStrings;
